import { useState } from 'react';

interface VisibleInCellProps {
  show_in_enterprise: boolean;
  show_in_ready: boolean;
  show_in_flex: boolean;
}

export const VisibleInCell = ({ show_in_enterprise, show_in_ready, show_in_flex }: VisibleInCellProps) => {
  const [listFormatter] = useState(() => new Intl.ListFormat('en-GB'));

  const visibleIn = [
    { label: 'Enterprise', value: show_in_enterprise },
    { label: 'Ready!', value: show_in_ready },
    { label: 'Flex', value: show_in_flex }
  ]
    .filter(item => item.value)
    .map(item => item.label);

  return listFormatter.format(visibleIn) || 'None';
};
